




























































import { Component, Prop, Vue } from "vue-property-decorator";
import ScoutingGroup from "@/models/ScoutingGroup";
import { currentScoutingStore } from "@/store/typed";
import VContentLoading from "@/components/VContentLoading.vue";
import GenericCable from "@/cables/GenericCable";

@Component({})
export default class ScoutingGroupItem extends Vue {
  @Prop({ required: true }) private readonly scoutingGroup!: ScoutingGroup;

  get selectedElementsCount() {
    if (this.scoutingGroup?.groupType === "area") {
      return this.scoutingGroup.scoutingAreas.length;
    } else {
      return this.scoutingGroup?.scoutingPlaces.length;
    }
  }

  get groupType() {
    return this.scoutingGroup?.groupType;
  }

  get isComplete() {
    return this.scoutingGroup.status === "analyzed";
  }

  get selectedElementsInfo() {
    let groupText = "";
    let selectionText = "";
    if (this.groupType === "area" && this.selectedElementsCount === 1) {
      groupText = "area";
      selectionText = "raggruppata";
    } else if (this.groupType === "area" && this.selectedElementsCount !== 1) {
      groupText = "aree";
      selectionText = "raggruppate";
    } else if (this.groupType === "place" && this.selectedElementsCount === 1) {
      groupText = "POI";
      selectionText = "ragruppato";
    } else if (this.groupType === "place" && this.selectedElementsCount !== 1) {
      groupText = "POI";
      selectionText = "ragruppati";
    }

    return `${this.selectedElementsCount} ${groupText} ${selectionText}`;
  }

  editClicked() {
    this.$emit("edit", this.scoutingGroup);
  }

  deleteClicked() {
    this.$emit("delete", this.scoutingGroup);
  }

  get isItemSelected() {
    return (
      currentScoutingStore.analysisCurrentScoutingGroup?.id ===
      this.scoutingGroup.id
    );
  }

  onClick() {
    if (!this.isComplete) {
      return;
    }
    this.$emit("select", this.scoutingGroup);
  }
}
